<template>
  <div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
            Aguarde! Atualizando ponto...<i class="pi pi-spin pi-spinner" ></i>
            <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
        </div>        
    </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Empresa</label>
                    <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"/>
                </div>              
            </div>
        </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col-12 p-md-3">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label>Portaria</label>
            <Dropdown v-model="portariaSelecionada" :options="portarias" optionLabel="nome" optionValue="valor" appendTo="body" @change="selecionarInfo"/>
        </div>
        <div class="p-field p-col-12 p-md-12">          
           <Message severity="info" :closable="false">{{ infoPortaria }}</Message>
           <Message severity="warn" :closable="false">
            <div class="p-pl-2">
                <h4 class="p-text-bold">Atenção!</h4>
                Para REP ControlID, importar o arquivo gerado pela porta fiscal.<br />
                Aguarde a finalização do processamento dos dados. Não navegue para outra tela.<br />
                Não faça edições no ponto ou qualquer ação que calcule o ponto no período selecionado.<br />
                Não é necessário calcular o ponto após ou no momento da importação do AFD.<br />
                Em caso de erro, não tente novamente, entre em contato com o suporte.<br />
            </div>
           </Message>
        </div>
    </div>
    <div class="p-d-flex p-jc-left" >
        <FileUpload ref="fileUpload" mode="basic" 
            :customUpload="true" 
            name="dados[]" 
            accept=".txt" 
            chooseLabel="Selecionar AFD..." 
            :disabled="disabledSelecionaArquivo" 
            @uploader="processar" 
            v-if="exibirBotaoUpload"/> 
        <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizar"/>  
    </div>     
  </div>
</template>

<script>
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import DocumentoService from '@/service/DocumentoService';
import RelatorioService from '@/service/RelatorioService';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR, minTrabPortarias } from '@/global';
import { mapGetters } from 'vuex';

export default {
    funcionarioPesquisaService: null,
    documentoService: null,
    relatorioService: null,
    data() {
        return {          
            progresso: 0,
            exibirBotaoUpload: true,
            disabledSelecionaArquivo: false,
            dataInicio: new Date(),
            dataFinal: new Date(),
            idCnpjSelecionado: null,
            cnpjs: [],
            localeCalendarBR: localeCalendarBR,        
            portarias: minTrabPortarias,  
            portariaSelecionada: minTrabPortarias[0].valor,
            infoPortaria: 'REP Homologado com a Portaria 1510 - Funcionário cadastrado com o PIS',
            pararTimeout: false
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getCacheEmpresa']), 
        /**
         * 
         * @param event 
         */  
        processar(event) {       
            this.pararTimeout = false;      
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let cnpj = null;
            for(let i = 0; i < this.cnpjs.length; i++) {
                if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                    cnpj = this.cnpjs[i];
                    break;
                }
            }
            let formData = new FormData();
            let jsonRequisicao = {
                numeroPortaria: this.portariaSelecionada,
                numCnpjRelogio: cnpj.numero,
                cnpj: cnpj,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                nomeDocumento: 'AFD',
                nomeArquivo: 'afd_' + cnpj.numero + '_' + Date.now() + '.txt',
                servico: 'arquivoAFD',
                tipoDocumento: 'txt',
                usuarioRequisicao: this.getDadosRequisicao()
            }
            formData.append('afdStream', event.files[0]);
            formData.append('jsonRequisicao', JSON.stringify(jsonRequisicao));
            this.documentoService.uploadAFDV2(formData)
            .then(resp => { 
                this.documento = resp.data;                
                if(this.documento.status == 'ERRO') {
                    let mensagemErro = this.documento.mensagem.split('#')[1];                    
                    exibirMensagemSis(this, mensagemErro, false);
                } else {
                    this.exibirBotaoUpload = false;
                    this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramentoAFD(resp.data);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)})
            .finally(()=> {        
                if(this.$refs.fileUpload) {
                    this.$refs.fileUpload.clear();   
                }           
                this.formData = null;
            });       
        },       
        /**
         * 
         * @param {*} event 
         */
        enviar(event) {             
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let cnpj = null;
            for(let i = 0; i < this.cnpjs.length; i++) {
                if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                    cnpj = this.cnpjs[i];
                    break;
                }
            }
            let formData = new FormData();
            formData.append('afdStream', event.files[0]);
            formData.append('jsonRequisicao', JSON.stringify({...this.getDadosRequisicao()}));
            formData.append('dtInicio', this.formatarData(this.dataInicio));
            formData.append('dtFinal', this.formatarData(this.dataFinal));  
            formData.append('numCnpjRelogio', cnpj.numero); 
            formData.append('numeroPortaria', this.portariaSelecionada);
            this.documentoService.uploadAFDV1(formData)
            .then(resp => { 
                this.paginarAFD(resp.data);
            })
            .catch(erro => {exibirMensagem(this, erro)})
            .finally(()=> {                
                this.$refs.fileUpload.clear();               
                this.formData = null;
            });       
        },
        /**
         * 
         */
        paginarAFD(dados) {
            this.disabledSelecionaArquivo = true;
            let requisicoes = [];
            let requisicao = { 
                arquivo: dados.arquivo, 
                indexs: [], 
                numCnpjRelogio: dados.numCnpjRelogio,
                usuarioRequisicao: this.getDadosRequisicao()
            };
            requisicoes.push(requisicao);
            let maximo = 20;
            let qtd = 0;
            dados.indexs.forEach(idxs => {
                if(qtd < maximo) {
                    qtd++;
                } else {
                    qtd = 1;                    
                    requisicao = { 
                        arquivo: dados.arquivo, 
                        indexs: [], 
                        numCnpjRelogio: dados.numCnpjRelogio,
                        usuarioRequisicao: this.getDadosRequisicao()
                    };
                    requisicoes.push(requisicao);
                }
                requisicao.indexs.push(idxs);
            });
            this.processarDadosAFDRecursivo(1, requisicoes);
        },
        /**
         * 
         */
        processarDadosAFDRecursivo(pagina, requisicoes) {
            if(this.pararTimeout) {
                return;
            }
            let requisicao = requisicoes[(pagina - 1)];  
            this.documentoService.processarDadosAFD(requisicao)
            .then(() => { 
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    this.disabledSelecionaArquivo = false;
                    exibirMensagemSis(this, 'Sucesso', false);
                    setTimeout(() => { this.progresso = 0; }, 1000);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.processarDadosAFDRecursivo(pagina, requisicoes);
                    }, 500);
                } 
            })
            .catch(erro => {
                this.disabledSelecionaArquivo = false;
                setTimeout(() => { this.progresso = 0; }, 1000);
                exibirMensagem(this, erro)
            });
        },
        /**
         * 
         */
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = cacheEmpresa.centrosCustos;       
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        }, 
        /**
         * 
         */
         finalizar() {            
            this.exibirBotaoUpload = true;
        },        
        /**
         * 
         */
        selecionarInfo() {
            if(this.portariaSelecionada == this.portarias[0].valor) {
                this.infoPortaria = 'REP Homologado com a Portaria 1510 - Funcionário cadastrado com o PIS';
            } else {// 671
                this.infoPortaria = 'REP Homologado com a Portaria 671 - Funcionário cadastrado com o CPF';
            }
        },
        /**
         * 
         * @param {*} data 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
    },
    created() {       
        this.documentoService = new DocumentoService();
        this.relatorioService = new RelatorioService();
        this.funcionarioPesquisaService = new FuncionarioPesquisaService();
        this.listarCnpjs();
    },
    beforeDestroy() {
        this.pararTimeout = true;
    },
    components: {      
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>
</style>